import { Table } from 'react-bootstrap';
import type { TopMcpToolRow } from '../../apps/apis/claudeCodeDashboard/types';
import { HELP_TEXT } from './agentTelemetryHelp';
import { HelpLabel } from './HelpTooltip';

interface Props {
  data: TopMcpToolRow[];
  countLabel?: 'Employees' | 'Sessions';
}

const getMcpColumns = (row: TopMcpToolRow) => {
  if (row.mcpTool) {
    return {
      server: row.mcpServer ?? '-',
      tool: row.mcpTool,
    };
  }

  if (row.mcpServer) {
    return {
      server: row.mcpServer,
      tool: '-',
    };
  }

  const name = typeof row.name === 'string' ? row.name : '';
  const separatorIndex = name.indexOf(':');
  if (separatorIndex === -1) {
    return {
      server: name || '-',
      tool: '-',
    };
  }

  return {
    server: name.slice(0, separatorIndex) || '-',
    tool: name.slice(separatorIndex + 1) || '-',
  };
};

const TopMcpToolsTable = ({ data, countLabel = 'Employees' }: Props) => {
  if (data.length === 0) {
    return <div className="text-muted small">No MCP tool invocations in the selected window.</div>;
  }
  return (
    <Table size="sm" hover responsive>
      <thead>
        <tr>
          <th>
            <HelpLabel description={HELP_TEXT.mcpServer}>MCP Server</HelpLabel>
          </th>
          <th>
            <HelpLabel description={HELP_TEXT.mcpTool}>Tool</HelpLabel>
          </th>
          <th className="text-end">
            <HelpLabel description={HELP_TEXT.invocations}>Invocations</HelpLabel>
          </th>
          <th className="text-end">
            <HelpLabel description={countLabel === 'Sessions' ? HELP_TEXT.sessions : HELP_TEXT.employees}>
              {countLabel}
            </HelpLabel>
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => {
          const columns = getMcpColumns(row);
          const count = countLabel === 'Sessions' ? row.uniqueSessions : row.uniqueEmployees;
          return (
            <tr
              key={typeof row.name === 'string' && row.name ? row.name : `${columns.server}:${columns.tool}:${index}`}
            >
              <td className="text-monospace">{columns.server}</td>
              <td className="text-monospace">{columns.tool}</td>
              <td className="text-end">{row.invocations.toLocaleString()}</td>
              <td className="text-end">{count?.toLocaleString() ?? '-'}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default TopMcpToolsTable;
